import { render, staticRenderFns } from "./ScrollToNext.vue?vue&type=template&id=21d77fed&scoped=true"
import script from "./ScrollToNext.vue?vue&type=script&lang=js"
export * from "./ScrollToNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d77fed",
  null
  
)

export default component.exports